
        var result = require("!!../node_modules/css-loader/dist/cjs.js!../node_modules/postcss-loader/src/index.js!./style.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    